// extracted by mini-css-extract-plugin
export default {"borderGrey":"#b5b4b5","zIndexModalBackdrop":"1040","question":"pyAu5tM5nqnoTjJP","text":"LWYp_wWmRJ9g4uXB"};